import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { type PreviewIncidentReportResponse } from '@roadfootage/api-client'

import logger from '../../logger'
import { useApi } from '../../composables/api'

const PAGE_SIZE = 16

export const useFeaturedStore = defineStore('featured', () => {
  const { featuredApi } = useApi()

  const isLoading = ref(false)
  const featuredIncidents = ref<PreviewIncidentReportResponse[]>([])
  const totalCount = ref(0)
  const hasMore = computed(() => featuredIncidents.value.length < totalCount.value)

  // Derived from item count so it can never drift out of sync across navigations.
  const nextPage = computed(() => Math.floor(featuredIncidents.value.length / PAGE_SIZE) + 1)

  function reset() {
    featuredIncidents.value = []
    totalCount.value = 0
    isLoading.value = false
  }

  async function fetchFeaturedIncidents() {
    if (isLoading.value) return
    logger.debug({ page: nextPage.value }, 'fetchFeaturedIncidents')
    isLoading.value = true
    try {
      const response = await featuredApi.featuredIndexFeaturedIncidents({
        pageSize: PAGE_SIZE,
        page: nextPage.value
      })
      if (response.items) {
        featuredIncidents.value.push(...response.items)
      }
      totalCount.value = response.totalCount ?? 0
    } catch (error) {
      logger.error({ error }, 'fetchFeaturedIncidents error')
    } finally {
      isLoading.value = false
    }
  }

  return {
    fetchFeaturedIncidents,
    reset,
    isLoading,
    featuredIncidents,
    hasMore
  }
})
